export default __webpack_public_path__ + "static/media/CNo.21-2.119b2591.jpg";